<script lang="ts" setup>
import BasketTitle from '@/components/Basket/basket-utils/BasketTitle.vue'

const emit = defineEmits(['showClearBasketDialog'])

const showClearBasketDialog = () => emit('showClearBasketDialog')
</script>

<template>
  <div class="header">
    <basket-title class="header__headline" title="Корзина" />

    <the-button
      variant="transparent"
      size="sm"
      radius="lg"
      icon="remove"
      type="button"
      @click="showClearBasketDialog"
    />
  </div>
</template>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__headline {
    margin-bottom: 0;
  }

  &__image {
    width: 24px;
    cursor: pointer;
  }

  @include media('<tablet') {
    margin-bottom: 15px;
  }
}
</style>
